// extracted by mini-css-extract-plugin
export default {"resetPasswordForm":"style_resetPasswordForm__rsf+G"};